import { selectTable, modifyTableValue, insertIntoValue, deleteTableValue } from '@/utils/mysqTools'
import { getInfo } from '@/api/user'
const state = {
  container: [
  ],
  userInfo: {
    // 用户信息
    userName: '',
    userId: ''
  }
}
const mutations = {
  // 从数据库拿数据
  updateContainer: (state, payload) => {
    state.container = []
    payload.forEach(element => {
      const obj = {
        id: element[0],
        userName: element[1],
        userId: element[2],
        modeType: element[3],
        input: element[4],
        img1: element[5],
        img2: element[6],
        img3: element[7],
        img4: element[8],
        uploadImage: element[9],
        uploadMask: element[10],
        referenceImage: element[11],
        steps: element[12],
        guidance: element[13],
        weight: element[14],
        cfg: element[15],
        realResolutionWidth: element[16],
        realResolutionHeight: element[17],
        resolutionMatchWidth: element[18],
        resolutionMatchHeight: element[19],
        loraName: element[20],
        galleryName: element[21],
        currentTime: element[22],
        taskLogId: element[23]
      }
      const exists = state.container.some(item => item.id === obj.id)
      if (!exists) {
        state.container.push(obj)
      }
    })
  }
}

const actions = {
  // 获取用户信息
  getUserInfo: async (context) => {
    const userInfo = await getInfo()
    context.state.userInfo.userName = userInfo.data.user.basic.c_name
    context.state.userInfo.userId = userInfo.data.user.basic.id
  },
  // 查询数据库
  queryTableData: async (context) => {
    try {
      const params = {
        userId: context.state.userInfo.userId
      }
      const result = await selectTable(params)
      context.commit('updateContainer', result.tables)
      return result
    } catch (error) {
      console.error('查询表数据失败:', error)
      throw error
    }
  },
  // 插入数据并更新 container
  insertAndRefresh: async (context, data) => {
    try {
      await insertIntoValue(data)
      await context.dispatch('queryTableData')
    } catch (error) {
      console.error('插入数据失败:', error)
      throw error
    }
  },

  // 修改数据并更新 container
  modifyAndRefresh: async (context, data) => {
    try {
      await modifyTableValue(data)
      await context.dispatch('queryTableData')
    } catch (error) {
      console.error('修改数据失败:', error)
      throw error
    }
  },

  // 删除数据并更新 container
  deleteAndRefresh: async (context, data) => {
    try {
      await deleteTableValue(data)
      await context.dispatch('queryTableData')
    } catch (error) {
      console.error('删除数据失败:', error)
      throw error
    }
  }

}
const getters = {
  sourceContainer: (state) => {
    return state.container
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}
